 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"admin.entrance~admin.extra~admin.index~admin.membership~admin.party~admin.pos~app~home~shop":"admin.entrance~admin.extra~admin.index~admin.membership~admin.party~admin.pos~app~home~shop","admin.entrance~admin.extra~admin.index~admin.membership~admin.party~admin.pos~app~shop":"admin.entrance~admin.extra~admin.index~admin.membership~admin.party~admin.pos~app~shop","admin.entrance~app~embed~shop~staff.scanner":"admin.entrance~app~embed~shop~staff.scanner","admin.entrance~admin.membership~brand~verify":"admin.entrance~admin.membership~brand~verify","admin.entrance":"admin.entrance","admin.extra":"admin.extra","brand~home":"brand~home","brand":"brand","verify":"verify","embed":"embed","admin.index~admin.membership~admin.party~admin.pos~app~auth~home~redeem~shop~staff":"admin.index~admin.membership~admin.party~admin.pos~app~auth~home~redeem~shop~staff","admin.membership":"admin.membership","app":"app","shop":"shop","home":"home","admin.index":"admin.index","admin.party":"admin.party","admin.pos":"admin.pos","auth~redeem":"auth~redeem","auth":"auth","redeem":"redeem","staff":"staff","auth.face":"auth.face","staff.scanner":"staff.scanner","proxy":"proxy","support":"support","terms":"terms"}[chunkId]||chunkId) + "." + {"admin.entrance~admin.extra~admin.index~admin.membership~admin.party~admin.pos~app~home~shop":"74484c34","admin.entrance~admin.extra~admin.index~admin.membership~admin.party~admin.pos~app~shop":"8e48f278","admin.entrance~app~embed~shop~staff.scanner":"02ee24df","admin.entrance~admin.membership~brand~verify":"7020fb0b","admin.entrance":"58a1096f","admin.extra":"1f2ad280","brand~home":"cedc2a55","brand":"731f5c72","verify":"f846e264","embed":"035f106a","admin.index~admin.membership~admin.party~admin.pos~app~auth~home~redeem~shop~staff":"4af21fd9","admin.membership":"c1928018","app":"5ed2d80b","shop":"5ee0fb46","home":"9e4a94b3","chunk-2d237713":"f2e0f8de","admin.index":"4ad71060","admin.party":"3544ce03","admin.pos":"a62edf47","auth~redeem":"e93b8301","auth":"98fd0270","redeem":"3f8a6901","staff":"9f4724b6","auth.face":"c72175d3","chunk-26cf3634":"a77422a8","staff.scanner":"b3a7e9bb","chunk-3f161b0a":"c197a9bf","chunk-6fd4e392":"fe59c81e","chunk-8b7d3786":"9398d26c","chunk-ac42ba74":"fdb6effb","chunk-adf6ee94":"c3244ffc","chunk-c1a37ede":"83685a1f","chunk-c7580a7a":"5a53bddb","proxy":"7593fd9b","support":"58568b9d","terms":"eaf5063d","chunk-2d0aab89":"c7d9c246","chunk-2d0bd650":"76c3f8cc","chunk-7f616413":"0fcc3279","chunk-2d0af25d":"37eb555d","chunk-2d0dea54":"a52188ff","chunk-2d225ba5":"7b8015b6","chunk-7473eec0":"be128d61","chunk-1026c39b":"9031628c","chunk-2d216214":"1f54003d","chunk-2d0d0eeb":"24b3e23d","chunk-2d207ead":"8a0236aa","chunk-2d219fc5":"23d7d672","chunk-52d7a51a":"d454f6e9","chunk-5eb24815":"47910f2e","chunk-670bbaa7":"9a4b8eef","chunk-127af846":"63e1d1b1","chunk-13c050cc":"af02acba","chunk-1b2305af":"7b542e98","chunk-89486c8e":"6462ae40","chunk-e4d700e2":"04e47e2b","chunk-6fcf5174":"9c0e6c01","chunk-c7e61d78":"0f3dae1b","chunk-e9cf0d84":"e62db715","chunk-040dd5dc":"4f5b281d","chunk-2f47013a":"d9d057ba","chunk-3cf95498":"ebd63d19","chunk-03f92ecf":"8c720627","chunk-09aee4e7":"75ebd968","chunk-0ba254a8":"24df581e","chunk-25abbb7c":"5dae7756","chunk-12c8da66":"2c2d2b9d","chunk-815f49ba":"5f0b9a84","chunk-2d0a3d15":"fa76a9b1","chunk-2d0f14fb":"8d51d2e5","chunk-8aedfcda":"16204f4f","chunk-d9d3c374":"f00e3cc4","chunk-44cc8add":"662ef1b9","chunk-44f701d6":"dde53a74","chunk-0eefa396":"057b51cd","chunk-ea181d8e":"bd64f0a0","chunk-01a2b568":"a928c2d9","chunk-f98d19c0":"8854fa82","chunk-3d9f8838":"fe265031","chunk-5828ea24":"6e2e6684","chunk-465e9f18":"8c19c6dc","chunk-7d21e770":"48b97c5a","chunk-bcaabcec":"b94f9a95","chunk-2d0e6c6b":"a2118baf"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"admin.entrance~admin.extra~admin.index~admin.membership~admin.party~admin.pos~app~home~shop":1,"admin.entrance~admin.extra~admin.index~admin.membership~admin.party~admin.pos~app~shop":1,"admin.entrance~app~embed~shop~staff.scanner":1,"admin.entrance":1,"admin.extra":1,"brand":1,"verify":1,"embed":1,"admin.membership":1,"app":1,"shop":1,"home":1,"admin.index":1,"admin.party":1,"admin.pos":1,"auth~redeem":1,"auth":1,"redeem":1,"staff":1,"auth.face":1,"chunk-26cf3634":1,"staff.scanner":1,"chunk-3f161b0a":1,"chunk-6fd4e392":1,"chunk-8b7d3786":1,"chunk-ac42ba74":1,"chunk-adf6ee94":1,"chunk-c1a37ede":1,"chunk-c7580a7a":1,"proxy":1,"support":1,"terms":1,"chunk-7f616413":1,"chunk-52d7a51a":1,"chunk-5eb24815":1,"chunk-670bbaa7":1,"chunk-127af846":1,"chunk-13c050cc":1,"chunk-1b2305af":1,"chunk-89486c8e":1,"chunk-6fcf5174":1,"chunk-c7e61d78":1,"chunk-e9cf0d84":1,"chunk-040dd5dc":1,"chunk-2f47013a":1,"chunk-3cf95498":1,"chunk-03f92ecf":1,"chunk-09aee4e7":1,"chunk-0ba254a8":1,"chunk-25abbb7c":1,"chunk-12c8da66":1,"chunk-815f49ba":1,"chunk-8aedfcda":1,"chunk-d9d3c374":1,"chunk-44cc8add":1,"chunk-44f701d6":1,"chunk-0eefa396":1,"chunk-ea181d8e":1,"chunk-01a2b568":1,"chunk-f98d19c0":1,"chunk-3d9f8838":1,"chunk-5828ea24":1,"chunk-465e9f18":1,"chunk-7d21e770":1,"chunk-bcaabcec":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"admin.entrance~admin.extra~admin.index~admin.membership~admin.party~admin.pos~app~home~shop":"admin.entrance~admin.extra~admin.index~admin.membership~admin.party~admin.pos~app~home~shop","admin.entrance~admin.extra~admin.index~admin.membership~admin.party~admin.pos~app~shop":"admin.entrance~admin.extra~admin.index~admin.membership~admin.party~admin.pos~app~shop","admin.entrance~app~embed~shop~staff.scanner":"admin.entrance~app~embed~shop~staff.scanner","admin.entrance~admin.membership~brand~verify":"admin.entrance~admin.membership~brand~verify","admin.entrance":"admin.entrance","admin.extra":"admin.extra","brand~home":"brand~home","brand":"brand","verify":"verify","embed":"embed","admin.index~admin.membership~admin.party~admin.pos~app~auth~home~redeem~shop~staff":"admin.index~admin.membership~admin.party~admin.pos~app~auth~home~redeem~shop~staff","admin.membership":"admin.membership","app":"app","shop":"shop","home":"home","admin.index":"admin.index","admin.party":"admin.party","admin.pos":"admin.pos","auth~redeem":"auth~redeem","auth":"auth","redeem":"redeem","staff":"staff","auth.face":"auth.face","staff.scanner":"staff.scanner","proxy":"proxy","support":"support","terms":"terms"}[chunkId]||chunkId) + "." + {"admin.entrance~admin.extra~admin.index~admin.membership~admin.party~admin.pos~app~home~shop":"701b962b","admin.entrance~admin.extra~admin.index~admin.membership~admin.party~admin.pos~app~shop":"a24c309a","admin.entrance~app~embed~shop~staff.scanner":"11cceed4","admin.entrance~admin.membership~brand~verify":"31d6cfe0","admin.entrance":"5854a96e","admin.extra":"541b79ef","brand~home":"31d6cfe0","brand":"812e3659","verify":"69af108a","embed":"e287307a","admin.index~admin.membership~admin.party~admin.pos~app~auth~home~redeem~shop~staff":"31d6cfe0","admin.membership":"6ded5d8b","app":"5fb6b70a","shop":"3cca40fa","home":"6e35a80d","chunk-2d237713":"31d6cfe0","admin.index":"a1833d11","admin.party":"305e619d","admin.pos":"2ff45021","auth~redeem":"c28a4616","auth":"16216942","redeem":"1b8b7975","staff":"aefd9c4b","auth.face":"ecc9ff9a","chunk-26cf3634":"e287307a","staff.scanner":"d424abbf","chunk-3f161b0a":"e1800d3d","chunk-6fd4e392":"e287307a","chunk-8b7d3786":"e287307a","chunk-ac42ba74":"e287307a","chunk-adf6ee94":"d885a853","chunk-c1a37ede":"e287307a","chunk-c7580a7a":"56edfc5c","proxy":"ab5d577f","support":"67baf795","terms":"cb15a1bb","chunk-2d0aab89":"31d6cfe0","chunk-2d0bd650":"31d6cfe0","chunk-7f616413":"039e3009","chunk-2d0af25d":"31d6cfe0","chunk-2d0dea54":"31d6cfe0","chunk-2d225ba5":"31d6cfe0","chunk-7473eec0":"31d6cfe0","chunk-1026c39b":"31d6cfe0","chunk-2d216214":"31d6cfe0","chunk-2d0d0eeb":"31d6cfe0","chunk-2d207ead":"31d6cfe0","chunk-2d219fc5":"31d6cfe0","chunk-52d7a51a":"9aa7e43e","chunk-5eb24815":"6beaaf3e","chunk-670bbaa7":"e9476362","chunk-127af846":"3112f544","chunk-13c050cc":"567a08ff","chunk-1b2305af":"a2900d46","chunk-89486c8e":"24b062c9","chunk-e4d700e2":"31d6cfe0","chunk-6fcf5174":"1b35f007","chunk-c7e61d78":"e7844dab","chunk-e9cf0d84":"14ac5de6","chunk-040dd5dc":"a2900d46","chunk-2f47013a":"5ec72dae","chunk-3cf95498":"ac7d0c52","chunk-03f92ecf":"782e62c4","chunk-09aee4e7":"24b062c9","chunk-0ba254a8":"a2900d46","chunk-25abbb7c":"3112f544","chunk-12c8da66":"11a5210d","chunk-815f49ba":"060c64bc","chunk-2d0a3d15":"31d6cfe0","chunk-2d0f14fb":"31d6cfe0","chunk-8aedfcda":"4eb0deb2","chunk-d9d3c374":"52aa4a62","chunk-44cc8add":"4866b390","chunk-44f701d6":"8ad0bb85","chunk-0eefa396":"52aa4a62","chunk-ea181d8e":"52aa4a62","chunk-01a2b568":"52aa4a62","chunk-f98d19c0":"545e41c5","chunk-3d9f8838":"545e41c5","chunk-5828ea24":"52aa4a62","chunk-465e9f18":"80abf5d1","chunk-7d21e770":"712fd543","chunk-bcaabcec":"52aa4a62","chunk-2d0e6c6b":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
